<template>
<div class="reply-item">
  <!-- <Avatar class="reply-avatar" :src="reply.user.avatar" :size="24" /> -->
  <slot name="prev"></slot>

  <div class="reply-author">
    <AuthorName class="reply-user" :uid="reply.user.uid" :name="reply.user.nickname" />

    <template v-if="reply.reply_user && reply.reply_user.uid">
      <span class="reply-label">回复</span>
      <AuthorName class="reply-user" :uid="reply.reply_user.uid" :name="reply.reply_user.nickname" />
    </template>
  </div>

  <slot name="content">
    <!-- <div class="reply-content">
      <div class="reply-text" v-html="replyContent"></div>
    </div> -->
    <div ref="replyContent" class="reply-content" :class="{'long-text': longText}">
      <span v-html="replyContent"></span>
      <div class="slidedown-btn" v-if="longText" @click="longText = false">
        展开全部
        <i class="iconfont">&#xe607;</i>
      </div>
    </div>
  </slot>
  <div class="reply-operation">
    <div class="date">{{reply.ctime | date('near')}}</div>
    <div class="reply-action">
      <span class="like-btn" :class="{liked: isLike}" @click="toggleLike">
        <i class="iconfont">&#xe644;</i>
        {{reply.love}}
      </span>
      <span class="reply-btn" @click="toggleReply">
        <i class="iconfont">&#xe643;</i>
        <em >回复</em>
      </span>
    </div>
  </div>
  <template v-if="isMobile">
    <CommentForm
      v-model.trim="replyValue"
      btnLabel="回复"
      :placeholder="`回复 ${reply.user && reply.user.nickname || ''}`"
      @close="replyFormShow = false"
      @click="submit"
      v-if="replyFormShow"
    />
  </template>
  <template v-else>
    <ReplyForm
      ref="replyTextarea" 
      :aid="aid"
      :replyData="reply"
      @submit="submit"
      @toggleReply="toggleReply"
      @updateReplyList="$emit('updateReplyList', $event)"
      v-if="replyFormShow"
    />
  </template>
  <slot name="extra"></slot>
</div>
</template>

<script>
import {mapState} from 'vuex'
import VueTypes from 'vue-types'
import gkButton from 'gkui/button'

import Avatar from '../../components/Avatar'
import AuthorName from '../../components/title/AuthorName'
import ReplyForm from './ReplyForm'
import CommentForm from './CommentForm'

import ArticleService from '../../service/article.service'
import utils from '../../utils'
import errorCode from '../../utils/errorCode'

export default {
  name: 'reply-item-pc',
  components: {
    gkButton,
    Avatar,
    AuthorName,
    ReplyForm,
    CommentForm
  },
  props: {
    reply: VueTypes.object.def({}),
    aid: VueTypes.oneOfType([Number, String]).def(''),
    isComment: VueTypes.bool.def(false)
  },
  data () {
    return {
      isLike: this.reply.is_love,
      replyFormShow: false,
      longText: false,
      replyValue: ''
    }
  },
  computed: {
    ...mapState(['isMobile', 'loginUser']),
    replyContent () {
      return utils.formatComment(this.reply.content)
    }
  },
  watch: {
    reply (reply = {}) {
      this.isLike = !!reply.is_love
    },
    replyFormShow (val) {
      if (val && !this.isMobile) {
        this.$nextTick(() => {
          this.$refs.replyTextarea.select()
        })
      }
    }
  },
  created () {
  },
  mounted () {
    this.longText = this.$refs.replyContent.offsetHeight > 30 * 5
  },
  methods: {
    /**
     * 喜欢/取消喜欢评论
     */
    toggleLike () {
      let type = this.isComment ? 2 : 3
      ArticleService.likeArticle(this.reply.id, !this.isLike, type).then(res => {
        this.isLike = !this.isLike
        this.isLike ? this.reply.love++ : this.reply.love--
      })
    },
    /**
     * 回复按钮点击   开关回复框
     */
    toggleReply () {
      if (!this.loginUser) {
        utils.login()
        return
      }

      this.replyFormShow = !this.replyFormShow
    },
    /**
     * 提交回复 移动端评论回复框 提交事件
     */
    submit ({clear, value, cb}) {
      const replyValue = this.isMobile ? this.replyValue : value
      const postData = {
        aid: this.aid,
        comment_id: this.isComment ? this.reply.id : this.reply.comment_id,
        content: replyValue
      }

      if (!this.isComment) {
        postData.reply_id = this.reply.id
      }

      ArticleService.addReply(postData).then(res => {
        this.$emit('updateReplyList', res)
        if (this.isMobile) {
          this.replyValue = ''
        } else {
          cb && cb()
        }
        this.replyFormShow = false
        clear && clear()
      }).catch(error => {
        if (error.api === 1 && errorCode[error.code]) {
          this.$Message.toast({
            message: errorCode[error.code]
          })
        }
        clear && clear()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/common';

.reply-item {
  position: relative;
  padding: 0 0 26px 5px;

  & .reply-author {
    line-height: 16px;
    @include font(16, 500);

    & .reply-user {
      @extend %animateFontBlack;
    }

    & .reply-label {
      padding: 0 2px;
      @include font(16, 400);
      color: $gray;
    }
  }

  & .reply-content {
    // display: flex;
    // flex-direction: column;
    // align-items: flex-start;
    // padding-top: 7px;
    margin: 7px 0 11px 0;
    line-height: 24px;
    @include font(16, 400);
    word-break: break-word;
    color: $lightBlack;

    &.long-text {
      overflow: hidden;
      position: relative;
      height: 120px;
    }

    & .slidedown-btn {
      position: absolute; right: 0; bottom: 0;
      background: #FFF;
      color: $blue;
      cursor: pointer;

      &:before {
        content: '...';
        color: $lightBlack;
      }
    }

    & .iconfont {
      position: relative; left: -2px; top: 3px;
      font-size: 20px;
    }
  }

  & .reply-text {
    flex: 1;
    // margin-right: 50px;
    line-height: 23px;
    @include font(16, 400);
    color: $lightBlack;
    word-break: break-all;
  }

  & .reply-operation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative; 
    width: 100%;
    margin-top: 10px;
    @include lineFont(14, 400);
    color: $black;

    & .date {
      @include font(14, 400);
      color: #828A92;
    }

    & .iconfont {
      font-size: 14px;
      color: $gray;
      user-select: none;
    }

    & .like-btn,
    & .reply-btn {
      color: $gray;
      cursor: pointer;
      user-select: none;

      &:hover,
      &:hover .iconfont {
        color: $grayHover;
      }
    }

    & .like-btn.liked {
      color: $blue;

      & .iconfont {
        color: $blue;
      }
    }

    & .reply-btn {
      margin-left: 18px;

      & .iconfont {
        position: relative; top: 1px;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .reply-item {
    & .wap-comment-btn {
      @include font(12, 400);
      line-height: 12px;
      color: $gray;
      vertical-align: middle;
    }
  }
}
</style>

 